import { createSlice } from '@reduxjs/toolkit'

/*
    currentUser is the synergist account/user object
    userInfo is the resume tool's representation of a user object
 */
export const userSlice = createSlice({
    name: 'user',
    initialState: {
        authenticated: false,
        currentUser: {},
        loading: false,
    },
    reducers: {
        setAuthenticated: (state, action) => {
            return {
                ...state,
                authenticated: action.payload,
            }
        },
        setCurrentUser: (state, action) => {
            return {
                ...state,
                currentUser: action.payload,
            }
        },
        setLoading: (state, action) => {
            return {
                ...state,
                loading: action.payload,
            }
        },
        setUserInfo: (state, action) => {
            return {
                ...state,
                userInfo: action.payload,
            }
        },
    },
})

export const { setAuthenticated, setCurrentUser, setLoading, setUserInfo } = userSlice.actions;

export default userSlice.reducer;